import {
  FETCH_MAP_PROPERTIES_REQUEST,
  FETCH_MAP_PROPERTIES_SUCCESS,
  FETCH_MAP_PROPERTIES_FAILURE,
  RESET_MAP,
} from './constants'
import type { FetchMapPropertiesParams } from './requests'
import type { mapDataSearchMapToPropertiesCollection } from './mappers'

export interface FetchMapPropertiesRequestAction {
  type: typeof FETCH_MAP_PROPERTIES_REQUEST
  payload: FetchMapPropertiesParams
}

interface FetchMapPropertiesSuccessAction {
  type: typeof FETCH_MAP_PROPERTIES_SUCCESS
  payload: {
    properties: ReturnType<typeof mapDataSearchMapToPropertiesCollection>
    keepProperties: boolean
  }
}

interface FetchMapPropertiesFailureAction {
  type: typeof FETCH_MAP_PROPERTIES_FAILURE
  payload: {
    error: string
  }
}

interface ResetMapAction {
  type: typeof RESET_MAP
}

export type MapActions =
  | FetchMapPropertiesRequestAction
  | FetchMapPropertiesSuccessAction
  | FetchMapPropertiesFailureAction
  | ResetMapAction

export const fetchMapPropertiesRequestAction = (
  payload: FetchMapPropertiesRequestAction['payload']
) => ({
  type: FETCH_MAP_PROPERTIES_REQUEST,
  payload,
})

export const fetchMapPropertiesSuccessAction = (
  payload: FetchMapPropertiesSuccessAction['payload']
) => ({
  type: FETCH_MAP_PROPERTIES_SUCCESS,
  payload,
})

export const fetchMapPropertiesFailureAction = (
  payload: FetchMapPropertiesFailureAction['payload']
) => ({
  type: FETCH_MAP_PROPERTIES_FAILURE,
  payload,
})

export const resetMapAction = () => ({
  type: RESET_MAP,
})
